import request from '@/utils/request'

export function updateConfigCdn(data) {
  return request({
    url: 'api/v1/tetris-config/uploadConfigCdn',
    method: 'post',
    data: data
  })
}

export function updateWeightCdn(data) {
  return request({
    url: 'api/v1/tetris-config/uploadWeightCdn',
    method: 'post',
    data: data
  })
}
